'use client';

import React, { useEffect } from 'react';
import Link from 'next/link';
import { AlertTriangle, RefreshCcw } from 'lucide-react';
import { Typography } from '@/components/ui/Typography';
import { Button } from '@/components/ui/Button';

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    // In a production app, log this error to an error reporting service like Sentry or Firebase Crashlytics
    console.error("Global Error Caught:", error);
  }, [error]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-4 text-center space-y-8">
      
      <div className="w-20 h-20 bg-red-500/10 text-red-500 rounded-full flex items-center justify-center mx-auto">
        <AlertTriangle className="w-10 h-10" />
      </div>

      <div className="space-y-4 max-w-lg">
        <Typography variant="h2" className="text-foreground">Something went wrong!</Typography>
        <p className="text-lg text-foreground/70">
          We encountered an unexpected error while trying to process your request. 
          Our team has been notified.
        </p>
        
        {/* Optional: Show technical error in dev mode */}
        {process.env.NODE_ENV === 'development' && (
          <div className="mt-4 p-4 bg-red-500/10 border border-red-500/20 rounded-md text-left overflow-auto max-h-40">
            <p className="text-sm font-mono text-red-600 break-words">
              {error.message || "Unknown error"}
            </p>
          </div>
        )}
      </div>

      <div className="flex flex-col sm:flex-row gap-4 pt-4">
        <Button 
          onClick={() => reset()}
          className="inline-flex items-center gap-2"
        >
          <RefreshCcw className="w-4 h-4" />
          Try Again
        </Button>
        <Link 
          href="/" 
          className="inline-flex items-center justify-center h-10 px-6 rounded-md bg-secondary text-foreground hover:bg-secondary/80 font-medium transition-colors border border-border"
        >
          Return Home
        </Link>
      </div>

    </div>
  );
}
